// Port of api/fuel/app/classes/model/insight/user/sync.php
import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'insight_user_sync',
	prefix: 'insight',
	key: 'insight_id',
	fields: {
		insight_id: Model.SCHEMA_KEY,
		user_id: Model.SCHEMA_NUMBER,
		insight_date: Model.SCHEMA_DATE,
		insight_stamp: Model.SCHEMA_TEXT,
		insight_space: Model.SCHEMA_NUMBER,
		insight_syncs_total: Model.SCHEMA_NUMBER,
		insight_syncs_auto: Model.SCHEMA_NUMBER,
		insight_syncs_manual: Model.SCHEMA_NUMBER,
		insight_syncs_deep: Model.SCHEMA_NUMBER,
		insight_syncs_standard: Model.SCHEMA_NUMBER,
		insight_syncs_full: Model.SCHEMA_NUMBER,
		insight_size_total: Model.SCHEMA_NUMBER,
		insight_size_deep: Model.SCHEMA_NUMBER,
		insight_size_standard: Model.SCHEMA_NUMBER,
		insight_size_full: Model.SCHEMA_NUMBER,
		insight_time_process_total: Model.SCHEMA_NUMBER,
		insight_time_process_deep: Model.SCHEMA_NUMBER,
		insight_time_process_standard: Model.SCHEMA_NUMBER,
		insight_time_process_full: Model.SCHEMA_NUMBER,
		insight_time_scrape_total: Model.SCHEMA_NUMBER,
		insight_time_scrape_deep: Model.SCHEMA_NUMBER,
		insight_time_scrape_standard: Model.SCHEMA_NUMBER,
		insight_time_scrape_full: Model.SCHEMA_NUMBER,
		insight_time_queued_auto_total: Model.SCHEMA_NUMBER,
		insight_time_queued_auto_standard: Model.SCHEMA_NUMBER,
		insight_time_queued_auto_full: Model.SCHEMA_NUMBER,
		insight_time_queued_manual_total: Model.SCHEMA_NUMBER,
		insight_time_queued_manual_deep: Model.SCHEMA_NUMBER,
		insight_time_queued_manual_standard: Model.SCHEMA_NUMBER,
		insight_time_queued_manual_full: Model.SCHEMA_NUMBER
	}
})
